import { render, staticRenderFns } from "./Navigation2.vue?vue&type=template&id=0296ba8e&scoped=true&"
import script from "./Navigation2.vue?vue&type=script&lang=ts&"
export * from "./Navigation2.vue?vue&type=script&lang=ts&"
import style0 from "./Navigation2.vue?vue&type=style&index=0&id=0296ba8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296ba8e",
  null
  
)

export default component.exports